import {
    inboxWorkflowColumn,
    inboxWorkflowPartialMessage,
    type InboxWorkflowCellComponent,
    type InboxWorkflowJson,
    type InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import SourceCleanupCompletionCell from "../../../../_shared/_modules/source-cleanup-completion-cell"
import SourceCleanupPreconfiguration from "../../../../_shared/_modules/source-cleanup-preconfiguration"
import ContactPointSourceCleanupCustomerCell from "./_modules/contact-point-source-cleanup-customer-cell"
import ContactPointSourceCleanupInstructionsCell from "./_modules/contact-point-source-cleanup-instructions-cell"
import ContactPointSourceCleanupPropertyCell from "./_modules/contact-point-source-cleanup-property-cell"
import ContactPointSourceCleanupSourceCell from "./_modules/contact-point-source-cleanup-source-cell"
import type { ContactPointSourceCleanupDraft, ContactPointSourceCleanupRow } from "./contract"
import { buildContactPointSourceCleanupRows } from "./_logic/tableRows"

export const sourceCleanupCells: Record<string, InboxWorkflowCellComponent> = {
  contactPointCleanupCompletion: SourceCleanupCompletionCell,
  contactPointCleanupCustomer: ContactPointSourceCleanupCustomerCell,
  contactPointCleanupInstructions: ContactPointSourceCleanupInstructionsCell,
  contactPointCleanupProperty: ContactPointSourceCleanupPropertyCell,
  contactPointCleanupSource: ContactPointSourceCleanupSourceCell,
}

export const createSourceCleanupStep = (): InboxWorkflowTableStepConfig<
  ContactPointSourceCleanupRow,
  ContactPointSourceCleanupDraft,
  InboxWorkflowJson
> => ({
  kind: "table",
  columns: [
    inboxWorkflowColumn(
      "sourceInstructions",
      "Im Kehrbezirksprogramm erledigen",
      "contactPointCleanupInstructions",
    ),
    inboxWorkflowColumn(
      "completion",
      "Im Kehrbezirksprogramm nachgetragen?",
      "contactPointCleanupCompletion",
    ),
    inboxWorkflowColumn("sourceLabel", "Herkunft", "contactPointCleanupSource"),
    inboxWorkflowColumn("addressLabel", "Liegenschaft", "contactPointCleanupProperty"),
    inboxWorkflowColumn("customerLabel", "Ansprechpartner", "contactPointCleanupCustomer", {
      isPrimary: true,
    }),
  ],
  buildRows: ({ workflow, step, rowOutcomes }) =>
    buildContactPointSourceCleanupRows({ workflow, step, rowOutcomes }),
  draft: {
    create: (row) => ({ completed: row.completed }),
    validate: (_row, draft) =>
      draft.completed
        ? null
        : "Bitte markieren Sie jede offene Zeile als im Kehrbezirksprogramm erledigt.",
  },
  preconfiguration: SourceCleanupPreconfiguration,
  buildPayload: () => ({}),
  commit: {
    label: "Nachtrag erledigt markieren",
    successMessage: "Nachtrag wurde als erledigt markiert.",
    partialMessage: inboxWorkflowPartialMessage,
  },
})
